<template>
  <transition name="slide-right">
    <cube-popup
      ref="myPopup"
      :visible="visible"
      type="my-popup"
      :center="false"
      position="right"
      class="filter-wrap"
    >
      <div
        ref="tree"
        class="tree_main"
      >
        <div class="select-list-tit">
          {{ $t('message["330"]') }} {{ adminidLTit[0] }}{{ checkList.length }}{{ adminidLTit[1] }}
        </div>
        <div
          class="select-list-list"
          :style="`height: ${getMH}px`"
        >
          <cube-index-list ref="cubeIndexList">
            <cube-index-list-group
              v-for="(group, index) in lastList"
              :key="index"
              :group="group"
            >
              <cube-index-list-item
                v-for="(item, index2) in group.items"
                :key="index2"
                :item="item"
              >
                <div class="custom-item">
                  <cube-checkbox
                    v-model="item.checked"
                    position="left"
                    shape="square"
                    @input="getval(item,$event)"
                  >
                    {{ item.name }}
                  </cube-checkbox>
                </div>
              </cube-index-list-item>
            </cube-index-list-group>
          </cube-index-list>
        </div>
      </div>
      <div
        class="foot-main"
      >
        <cube-button
          @click.stop="hide('reset')"
        >
          {{ $t('message["896"]') }}
        </cube-button>
        <cube-button
          @click.stop="hide('sub')"
        >
          {{ $t('message["915"]') }}
        </cube-button>
      </div>
    </cube-popup>
  </transition>
</template>
<script type="text/ecmascript-6">
import { mapState } from 'vuex'
export default {
  components: {
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isVisible: false,
      checkList: []
    }
  },
  computed: {
    ...mapState('organization/org', ['adminListDatas']),
    adminidLTit () {
      return this.$t('message["333"]').split('|')
    },
    lists () {
      const { adminListDatas } = this
      let obj = {}
      const arr2 = [ 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z' ]
      for (let i = 0; i < arr2.length; i++) {
        obj[arr2[i]] = []
        adminListDatas.forEach((item, index) => {
          item.value = item.userid
          item.name = item.truename
          this.$set(item, 'checked', false)
          if (arr2[i] === item.firstchar) {
            obj[arr2[i]].push(item)
          }
        })
      }
      return obj
    },
    lastList () {
      let arr = []
      for (let [key, value] of Object.entries(this.lists)) {
        if (value.length) {
          arr.push({
            name: key,
            items: value
          })
        }
      }
      return arr
    },
    getMH () {
      // const contentH = this.$refs.cubeIndexList.offsetHeight
      return window.screen.availHeight - 220
    }
  },
  watch: {
    visible (val) {
      this.isVisible = val
    }
  },
  mounted () {
  },
  methods: {
    hide (type) {
      this.$refs.myPopup.hide()
      this.checkList = type === 'reset' ? [] : this.checkList
      if (type === 'reset') {
        this.lastList.forEach(item => {
          if (item.items && item.items.length) {
            item.items.forEach(item2 => {
              if (item2.checked) {
                item2.checked = false
              }
            })
          }
        })
      }
      this.$emit('close', false, this.checkList)
    },
    selectItem (item, d) {
      // console.log(item, d)
    },
    clickTitle (title) {
      console.log(title)
    },
    getval (item, $event) {
      console.log(item.checked)
      const index = this.checkList.findIndex(item2 => item2.userid === item.userid)
      if ($event && (index === -1)) {
        this.checkList.push({ userid: item.userid, name: item.name })
      } else if (!$event && (index > -1)) {
        this.checkList.splice(index, 1)
      }
      this.$forceUpdate()
      // console.log(this.checkList)
      return false
      // this.$emit('getadminList', this.checkList)
    }
  }
}

</script>
<style lang="scss" scoped>
.slide-right-enter,
.slide-right-leave-active {
  -webkit-transform: translate3d(100%, 0, 0);
  transform: translate3d(100%, 0, 0);
}

.slide-right-enter-active,
.slide-right-leave-active {
  -webkit-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
}

.tree_main::v-deep {
  position: relative;
  // top: 0;
  height: 100%;
}
.select-list-tit {
  border-bottom: 1px solid #dbdbdb;
  padding: 0 15px;
}
.foot-main {
  position: fixed;
  width: 100%;
  height: 62px;
  bottom: 0;
  z-index: 100;
  background: #fff;
  button {
    display: inline-block;
    width: 176px;
    height: 46px;
    box-sizing: border-box;
    background: #fff;
    border:1px solid rgba(219,219,219,1);
    color: #333;
    margin: 8px;
  }
  button:nth-child(2) {
    margin: 8px 0 0 0;
    background:linear-gradient(360deg,rgba(80,119,170,1) 0%,rgba(96,143,204,1) 100%);
    box-shadow:0px 1px 1px 0px rgba(255,255,255,0.5);
    border-radius:4px;
    border:1px solid rgba(80,119,170,1);
    color: #fff
  }
}
.select-list-list::v-deep {
  overflow-y: auto;
  .cube-index-list {
    // padding: 0 10px;
    // overflow:visible;
    .cube-scroll-wrapper {
      position: static;
    }
    .cube-index-list-item {
      line-height: 48px;
      height: 48px;
      border-bottom: 1px solid #dbdbdb;
      padding: 0 15px;
    }
    .cube-index-list-anchor {
      padding: 12px 16px 6px;
      border-bottom: 1px solid #dbdbdb;
    }
    .cube-index-list-nav {
      display: none;
    }
    .cube-scroll-content {
      z-index: 0;
    }
  }
}
</style>
